/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-modal-title[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block}.title[_ngcontent-%COMP%]{width:calc(100% - 40px)}.msg-item[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{display:inline-block;vertical-align:top}.msg-content[_ngcontent-%COMP%]{white-space:pre-line}\n/*# sourceMappingURL=view-log.component.css.map*/"];
export { styles as styles };
